let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aivYr")).then(() => parcelRequire('8U9L5'));